import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}))

export default ({ startDate, onChange }) => {
    const classes = useStyles()

    return (
        <form className={classes.container} noValidate>
            <TextField
                id="date"
                type="date"
                value={startDate}
                onChange={(event) => onChange(event.target.value)}
                onChangeText={() => null}
                className={classes.textField}
                InputLabelProps={{
                    shrink: true,
                    required: true,
                }}
            />
        </form>
    )
}
